<template>
  <div
    v-if="
      suggestWords.length ||
      products.length ||
      (searchKeywords.length && showRecordLayer)
    "
    class="header-search"
  >
    <div
      v-if="suggestWords.length || products.length"
      class="header-search__results"
    >
      <ul v-if="count > 0 && cardInfos && cardInfos.length > 0">
        <!-- <ul v-if="count > 0"> -->
        <li class="header-search__item">
          <a
            href="javascript:;"
            @mousedown.prevent="gotoCard()"
            class="clearfix"
          >
            <span class="fl header-search__key">
              <span class="header-search__word">{{ keyword }}</span>
              <strong>{{ TLang("可用福利卡抵扣的商品", "my") }}</strong>
            </span>
            <span class="fr header-search__num"
              >{{ TLang("约", "my") }}{{ count
              }}{{ TLang("个商品", "my") }}</span
            >
          </a>
        </li>
      </ul>
      <ul v-if="suggestWords.length">
        <li
          class="header-search__item"
          v-for="(item, index) of suggestWords"
          :key="`suggestWords_${index}`"
        >
          <a
            href="javascript:;"
            @mousedown.prevent="gotoSuggestWords(item.word)"
            class="clearfix"
          >
            <span
              class="fl header-search__key"
              v-if="item.highlight"
              v-html="item.highlight"
            ></span>
            <span class="fl header-search__key" v-else>{{ item.word }}</span>
          </a>
        </li>
      </ul>
      <ul v-if="products.length">
        <li
          v-for="(item, index) of products"
          :key="`item${index}`"
          class="header-search__item"
        >
          <a
            href="javascript:;"
            class="clearfix"
            @mousedown.prevent="goto(false, item.productType)"
          >
            <span class="fl header-search__key">
              <!-- {{ keyword }} -->
              <span class="header-search__word">{{ keyword }}</span>
              <!-- <strong>{{ item.productType }}</strong> -->
              <strong>{{ item.productTypeText }}</strong>
            </span>
            <span class="fr header-search__num"
              >{{ TLang("约", "my") }}{{ item.qty
              }}{{ TLang("个商品", "my") }}</span
            >
          </a>
        </li>
      </ul>
    </div>
    <div
      v-if="searchKeywords.length && showRecordLayer"
      class="header-search__record"
    >
      <div class="clearfix header-search__record_all">
        <span class="fl header-search__key">{{ TLang("最近搜过", "my") }}</span>
        <span
          class="fr header-search__num"
          @mousedown.prevent="deleteAllCookies"
          >{{ TLang("全部删除", "my") }}</span
        >
      </div>
      <ul>
        <li
          v-for="(item, index) of searchKeywords"
          :key="item"
          class="header-search__item"
        >
          <a href="javascript:;" class="clearfix">
            <span
              class="fl header-search__key"
              @mousedown.prevent="onSubmit($event)"
              >{{ item }}</span
            >
            <span
              class="fr header-search__num"
              @mousedown.prevent="deleteCurCookie(index)"
              >{{ TLang("删除", "my") }}</span
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { gioClickHandle as gioHandle, getQueryString } from "../../utils";
import SingleTag from "../singleTag";
export default {
  components: {
    SingleTag,
  },
  props: {
    searches: {
      type: Array,
      default: () => [],
    },
    suggestWords: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    cardInfos: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 0,
    },
    records: {
      type: Array,
      default: () => [],
    },
    keyword: {
      type: String,
      default: "",
    },
    cid: {
      type: Number,
      default: 145,
    },
    showRecordLayer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchKeywords: this.infoState(this.records),
    };
  },
  // created() {
  //   var addCookie = function (sName , sValue , day) {
  //     var expireDate = new Date();
  //     expireDate.setDate(expireDate.getDate() + day);
  //     //设置失效时间
  //     document.cookie = sName + '=' + encodeURIComponent(sValue) + ';expires=' + expireDate.toGMTString() + ';path=/';   //toGMTString() 把日期对象转成字符串
  //   }
  //   addCookie('searchKeywords', '张飞,礼', '2031-12-08T07:24:58.000Z')
  // },
  methods: {
    infoState(obj) {
      let arr = obj.slice(0, 10);
      return arr;
    },
    goto(picUrl, productType) {
      if (picUrl) {
        const { hostname } = window.location;
        const arr = [...this.searchKeywords].filter(
          (item) => item !== this.keyword
        );

        // arr.push(this.keyword);
        arr.unshift(this.keyword);
        // 设置cookie
        this.publicMethod.setCookie(
          "searchKeywords",
          arr.join(","),
          604800,
          "/",
          `.${hostname}`
        );

        window.df_sdk_common.location.href = picUrl;
      } else {
        let pathName = window.location.pathname;
        let channelName = "优选生活";
        if (pathName.indexOf("home") > -1) {
          channelName = "优选生活";
        } else if (pathName.indexOf("book") > -1) {
          channelName = "图书";
        } else if (pathName.indexOf("birthday") > -1) {
          channelName = "生日汇";
        } else if (getQueryString("productTypes")) {
          channelName = getQueryString("productTypes");
        }

        gioHandle(
          "DF_elementClick",
          {
            df_channle: channelName,
            df_pagename: "搜索页",
            df_modulename: "快速搜索",
            df_elementname: "产品类型",
            df_pageType: productType,
            df_searchKeyword: this.keyword || "未输入关键词",
          },
          "channelGio"
        );
        debugger;
        const { origin } = window.location;
        const URL = `${origin}/health/search?keywords=${
          this.keyword
        }&productType=${productType}&city=${
          (Cookies.get("address") &&
            JSON.parse(Cookies.get("address") || "{}").cityId) ||
          "145"
        }`;

        window.df_sdk_common.location.href = URL;
      }
    },
    gotoSuggestWords(keyword) {
      let pathName = window.location.pathname;
      let channelName = "优选生活";
      if (pathName.indexOf("home") > -1) {
        channelName = "优选生活";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }
      gioHandle(
        "DF_elementClick",
        {
          df_channle: channelName,
          df_pagename: "搜索页",
          df_modulename: "快速搜索",
          df_elementname: "搜索联想词",
          df_searchKeyword: this.keyword || "未输入关键词",
          df_content: keyword,
        },
        "channelGio"
      );
      this.$emit("onSubmit", keyword, keyword);
    },
    gotoCard() {
      // cardChoose传1 表示选择了卡权益
      const { origin } = window.location;
      const URL = `${origin}/health/search?keywords=${this.keyword}&city=${
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityId) ||
        "145"
      }&cardChoose=1`;
      let pathName = window.location.pathname;
      let channelName = "优选生活";
      if (pathName.indexOf("home") > -1) {
        channelName = "优选生活";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }
      // 埋点不处理翻译
      gioHandle("DF_elementClick", {
        df_channle: channelName,
        df_searchKeyword: this.keyword || "未输入关键词",
        df_modulename: "快速搜索",
        df_elementname: "权益",
        df_pagename: "搜索页",
      },"channelGio");

      setTimeout(() => {
        window.df_sdk_common.location.href = URL;
      }, 500);
    },
    deleteCurCookie(index) {
      const { hostname } = window.location;

      this.searchKeywords.splice(index, 1);
      this.publicMethod.setCookie(
        "searchKeywords",
        this.searchKeywords.join(","),
        604800,
        "/",
        `.${hostname}`
      );
      // 更新搜索历史记录
      this.$emit("updateRecord", this.searchKeywords);
    },
    deleteAllCookies() {
      const { hostname } = window.location;
      this.publicMethod.removeCookie("searchKeywords", "/", `.${hostname}`);
      this.searchKeywords = [];
      // 更新搜索历史记录
      this.$emit("updateRecord", this.searchKeywords);
    },
    async onSubmit(ev) {
      const city = (Cookies.get("address") &&
            JSON.parse(Cookies.get("address") || "{}").cityId) ||
          "145";
      const res = await this.apis.headerApi.getSearchUrl({keyword: this.keyword, city});
      let pathName = window.location.pathname;
      let channelName = "全部";
      if (pathName.indexOf("home") > -1) {
        channelName = "全部";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }
      gioHandle("DF_elementClick", {
        df_channle: channelName,
        df_pagename: '搜索页',
        df_modulename: '搜索历史',
        df_elementname: '搜索历史词',
        df_searchKeyword: ev.target.innerText,
        df_pageType: res && res.body && res.body.linkUrl?'词链':'',

      });
      if(res && res.body && res.body.linkUrl){
        window.df_sdk_common.location.href = res.body.linkUrl;
      } else {
        this.$emit('onSubmit', ev, ev.target.innerText);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-search {
  position: absolute;
  top: 87px;
  right: 0;
  z-index: 9999;
  border: 1px solid #c9c9c9;
  background-color: #fff;
  width: 397px;
  padding-top: 5px;
  padding-bottom: 5px;
  &__item {
    > a {
      display: block;
      padding: 5px 10px;
      &:hover {
        background-color: #f8f8f8;
      }
    }
  }
  &__key {
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
  }
  &__word{
    color: red;
    margin-right: 4px;
  }
  &__num {
    width: 25%;
    text-align: right;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__record {
    &_all {
      padding: 5px 10px;
      .header-search__num {
        cursor: pointer;
      }
    }
    a {
      padding: 5px 10px;
      .header-search__num {
        display: none;
      }
      &:hover {
        .header-search__num {
          display: block;
        }
      }
    }
  }
}

.fl {
  float: left;
}
.fr {
  float: right;
}
</style>
